module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Zurück","categories":"Kategorien","ourFoodTrucks":"Unsere Foodtrucks","ourPartners":"Unsere Partner","ourSpots":"Unsere Spots"},"en":{"back":"Back","categories":"Categories","ourFoodTrucks":"Our food trucks","ourPartners":"Our partners","ourSpots":"Our spots"}}')
  delete Component.options._Ctor
}
